import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/core/services/data.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
    selector: 'app-mail-verification',
    templateUrl: './mail-verification.component.html',
    styleUrls: ['./mail-verification.component.css', '../../shared/styles/common.css'],
    standalone: false
})
export class MailVerificationComponent implements OnInit {
  name = new FormControl('');
  email: any;
  submitted = false;

  message: string = '';
  subscription: any;
  countdown: number = 300; // 3 minutes in seconds
  displayTime: any = '05:00';
  interval: any;
  showSuccessDialog = false;

  constructor(private toastr: ToastrService, private data: DataService ,private http: HttpClient, private formBuilder: FormBuilder, private router: Router, private authService: AuthService) { }

  myForm = this.formBuilder.group({
    token: ['', Validators.required],
  })
 
  ngOnInit(): void {

    this.subscription = this.data.currentMessage.subscribe(message => {
      this.message = message;
    });
    // //console.log("here is the mail", this.message);

    // if(this.message == "" || this.message == "default message") {
    //   this.router.navigate(['/register']);
    // }
    this.startTimer();
  }

  get f() { return this.myForm.controls; }

  resend_token() {
    // if(this.message == "" || this.message == "default message") {
    //   this.router.navigate(['/register']);
    // }
    clearInterval(this.interval);
    
    this.authService.resend_token(this.message).subscribe({
      next: (res: HttpResponse<any>) => {
        this.toastr.success(res.body.msg);
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 500) {
          this.toastr.error('Enter valid token');
        } else {
          this.toastr.error('An error occurred. Please try again.');
        }
      }
    });

    this.countdown = 300;
    this.displayTime = '05:00';
    this.startTimer();
  }

  onSubmit(token: string){
    //this.showSuccessDialog = true;
    this.submitted = true;
    if (this.myForm.invalid) {
      return;
    }
    
    // this.authService.mail_verification(token, this.message).subscribe((res: HttpResponse<any>) => {
    //   if(!res.body.error) {
    //     // this.router.navigate(['/login']);
    //     // this.toastr.success(res.body.msg, "Success!");
    //     this.showSuccessDialog = true;
    //   } else {
    //     this.toastr.error(res.body.msg);
    //   }
    // })

    this.authService.mail_verification(token, this.message).subscribe({
      next: (res: HttpResponse<any>) => {
        if (!res.body.error) {
          this.showSuccessDialog = true;
        } else {
          this.toastr.error(res.body.msg || 'Verification failed');
        }
      },
      error: (err) => {
        // This handles the 400 Bad Request
        if (err.status === 400 && err.error?.msg) {
          this.toastr.error(err.error.msg);
        } else {
          this.toastr.error('An unexpected error occurred', 'Error');
        }
      }
    });
  }
  
  onCancel(){
    this.router.navigate(['/register']);
  }
  startTimer() {
    this.interval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
        this.displayTime = this.formatTime(this.countdown);
      } else {
        clearInterval(this.interval); // Stop timer at 00:00
      }
    }, 1000);
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
  closeSuccessDialog() {
    this.showSuccessDialog = false;
    this.router.navigate(['/login']); // Redirect after closing the popup
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  restricttextSpace(event: any) {
		let inputValue: string = event.target.value;
		inputValue = inputValue.replace(/^\s+/, '');
		inputValue = inputValue.replace(/\s{2,}/g, ' ');
		event.target.value = inputValue;
		return;
	}
}
